import { Tabs } from 'react-tabs';

export default Tabs;
